import axios from "axios";
import i18next from "i18next";
import { useQuery } from "react-query";
import getEnv, { getGA } from "../utils/getAppEnv";
import getBaseUrl from "../utils/getBaseUrl";

export function useSearchMount(
  rpm: string,
  kg: string,
  noOfMount: string,
  failSafe = false
) {
  const queryResult = useQuery(
    ["getAVSMountSearchResult", rpm, kg, noOfMount, failSafe],
    async ({ queryKey }) => {
      const [_key, rpm, kg, noOfMount, failSafe] = queryKey;
      if (
        rpm &&
        (rpm as string).length > 2 &&
        kg &&
        noOfMount &&
        Number(rpm) &&
        Number(kg) &&
        Number(noOfMount)
      ) {
        const url = `${getBaseUrl()}productcontroller/${_key}`;
        try {
          const response = await axios.post(url, {
            machinWeight: kg,
            machineSpeed: rpm,
            numOfMounts: noOfMount,
            failsafe: failSafe,
          });
          response.data.length &&
            (window as any).dataLayer.push({
              event: "engagement",
              eventCategory: "Mountfinder Search",
              eventAction: "Search ", // 'Weight of the Machine', 'Machine Speed', 'Number of Mounts' and 'Category'
              eventLabel: {
                machinWeight: kg,
                machineSpeed: rpm,
                numOfMounts: noOfMount,
                failsafe: failSafe,
              },
              resultsCount: response.data.length,
            });

          return response.data;
        } catch (error) {
          console.log(error);
          throw new Error("Network response was not ok");
        }
      }
      return undefined;
    }
  );

  return { ...queryResult };
}
